import { cashBalanceApi } from './cash-balance.api';
import { CreateFinalBalanceDto } from '@sr/dto';

export const useSaveFinalBalance = () => {
  const [saveFinalBalance] = cashBalanceApi.useSaveFinalBalanceMutation();
  
  return async (dto: Omit<CreateFinalBalanceDto, 'createdById'>) => {
    const result = await saveFinalBalance(dto).unwrap();
    return result;
  };
};